import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEPRECATED_PAYOUT_ORDER_STATUSES } from 'constants/order.constants';
import {
  AdditionalOrderColumn,
  FilterDefinitionType,
  OrdersTab,
  PayoutOrderStatus,
  PayoutOrderStatusDetails,
} from 'enums';
import { useQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { ManageOrdersList } from '../ManageOrderList';

export const AllOrders: React.FC = () => {
  useQueryFilters<OrderFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
    statuses: [PayoutOrderStatus.Completed, PayoutOrderStatus.Cancelled],
  });

  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      orderUtils.getStatusFilterDefinition(
        Object.values(PayoutOrderStatus).filter(
          (status) => !DEPRECATED_PAYOUT_ORDER_STATUSES.includes(status),
        ),
      ),
      {
        label: tFilters('status_details'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: PayoutOrderStatusDetails,
        getDisplayName: orderUtils.getPayoutStatusDetailsLabel,
      },
    ],
    [tFilters],
  );

  return (
    <ManageOrdersList
      tab={OrdersTab.All}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.TraderPayment,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.Validation,
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.OrderProcessedBy,
      ]}
    />
  );
};
